// extracted by mini-css-extract-plugin
module.exports = {"date":"day__styles__date--26Fh-49M","day":"day__styles__day--8znyrIyh"};